import classNames from 'classnames/bind';
import React from 'react';
import { Button, ButtonMode, Modal, ModalWidth } from '@creditsights/styleguide-web';
import { useGlobalModalContext } from '../../../GlobalModal';
import { Analyst } from '../../../../models';
import AnalystsContent from '../AnalystsContent';

import styles from './AnalystsModal.module.scss';

const cx = classNames.bind(styles);

interface AnalystsModalProps {
  data: Analyst[];
  onAskAnalystClick: () => void;
  hideDeactivatedAnalyst?: boolean;
  canAskAnAnalyst: boolean;
}

const AnalystsModal = ({
  data,
  hideDeactivatedAnalyst,
  onAskAnalystClick,
  canAskAnAnalyst,
}: AnalystsModalProps): React.ReactElement => {
  const { closeModal } = useGlobalModalContext();

  const renderAskAnAnalyst = () => {
    if (!canAskAnAnalyst) {
      return undefined;
    }
    return (
      <Button
        className={cx('button')}
        mode={ButtonMode.PRIMARY}
        onClick={onAskAnalystClick}
        dataTestId="analyst-button-modal"
      >
        Ask an Analyst
      </Button>
    );
  };

  return (
    <Modal
      className={cx('body')}
      width={ModalWidth.Small}
      open
      onClose={closeModal}
      headerTitle="Analysts"
      footer={renderAskAnAnalyst()}
    >
      <AnalystsContent data={data} hideDeactivatedAnalyst={hideDeactivatedAnalyst} />
    </Modal>
  );
};

export default AnalystsModal;
